module.exports = __webpack_public_path__ + "img/img_label_buy_coupon.48ddd07f.png";